import React from 'react'

function getInitials(name, email) {
  if (name) {
    const parts = name.trim().split(/\s+/)
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase()
    return parts[0].substring(0, 2).toUpperCase()
  }
  if (email) return email.substring(0, 2).toUpperCase()
  return '??'
}

export default function AttendeeList({ rsvps = [] }) {
  if (rsvps.length === 0) {
    return (
      <div className="text-center py-6">
        <p className="text-charcoal-muted text-sm">No attendees yet.</p>
      </div>
    )
  }

  return (
    <div className="space-y-2">
      {rsvps.map((rsvp) => {
        const user = rsvp.user || {}
        const initials = getInitials(user.name, user.email)
        return (
          <div
            key={rsvp.id}
            className="flex items-center gap-3 py-2 px-3 rounded hover:bg-surface-linen/50 transition-colors"
          >
            <div className="w-8 h-8 rounded-full bg-gold/15 flex items-center justify-center text-charcoal font-bold text-xs flex-shrink-0">
              {initials}
            </div>
            <div className="min-w-0">
              <p className="text-sm font-medium text-charcoal truncate">
                {user.name || user.email || 'Unknown'}
              </p>
            </div>
          </div>
        )
      })}
    </div>
  )
}
